"use strict";

const $ = require("jquery");
const globals = require("js/globals");
const eventStreamModule = require("js/eventstream");
const phoenix = require("phoenix");
const alerts = require("js/alert.js");

const MODULE = "Cards";
const INITIALISED = "cardsInitialised";
const cardChangeSource = globals.getStorage(MODULE, "cardChangeSource", eventStreamModule.eventSource());
const cardDeleteSource = globals.getStorage(MODULE, "cardDeleteSource", eventStreamModule.eventSource());

function init() {
    const isInitialised = globals.getStorage(MODULE, INITIALISED, false);

    if (!isInitialised) {
        globals.setStorage(MODULE, INITIALISED, true);
    }
}

function __notifyCardChangesInResponse(resp) {
    if (resp.card != null) {
        cardChangeSource.notify(resp);
    }

    return resp;
}

function __showApiResponse(resp) {
    if (resp.msg != null) {
        alerts.showApiResponse(document, resp);
    }

    return resp;
}

// utility functions to replace the json formatted date with new Date objects
function setDatesOnCards(cards) {
    return cards.map((shortCard) => setDatesOnCard(shortCard));
}

function setDatesOnCard(card) {
    card.updatedAt = new Date(card.updatedAt);
    return card;
}

function listCategories(limitToHorizonId, requiredIds = [], excludeSnapshots = false) {
    return $.ajax({
        url: "/api/categories",
        method: "GET",
        data: {
            limit_to_horizon_id: limitToHorizonId,
            required_ids: requiredIds,
            exclude_snapshots: excludeSnapshots,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        dataType: "json",
    }).fail(alerts.httpFailure);
}

function listCards({ filterId = null, limitToHorizonId = null }) {
    const data = {
        filterId: filterId,
        limit_to_horizon_id: limitToHorizonId,
    };

    return $.ajax({
        url: "/api/cards",
        method: "GET",
        data: data,
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        dataType: "json",
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure)
        .then((cards) => setDatesOnCards(cards));
}

function loadCard(id, { componentIdentifier = null, isPartnerRequest = null }) {
    console.log("Load card by id", id);

    const mainLiveViewContainer = document.querySelectorAll("*[data-phx-main]");

    if (mainLiveViewContainer.length != 1) {
        throw new Error(
            "Expected to find exactly one main live view container, but found: " + mainLiveViewContainer.length,
        );
    }

    return $.ajax({
        url: "/api/cards/" + id,
        method: "GET",
        data: {
            componentIdentifier: componentIdentifier,
            isPartnerRequest: isPartnerRequest,
            liveViewId: mainLiveViewContainer[0].id,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        dataType: "json",
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure)
        .then((card) => setDatesOnCard(card));
}

function saveCard({
    id = null,
    title = null,
    content = null,
    cardType = null,
    cardsInCategory = [],
    inCategories = [],
    cardRelations = [],
    relationsDeletedByUser = [],
    chatWith = [],
    publish = false,
    attachments = [],
    currentHorizon = currentHorizon,
    takeSnapshot = false,
    autoSave = false,
}) {
    let method;
    let url = takeSnapshot ? "/api/cards/update_and_snapshot" : "/api/cards";

    let data = {
        card: {
            inCategories: inCategories,
            cardRelations: cardRelations,
            relationsDeletedByUser: relationsDeletedByUser,
            cardsInCategory: cardsInCategory,
            chatWith: chatWith,
            publish: publish,
            attachments: attachments,
            currentHorizon: currentHorizon,
            autoSave: autoSave,
        },
    };

    if (title != null) data.card["title"] = title;
    if (cardType != null) data.card["type"] = cardType;
    if (content != null) data.card["content"] = content;

    if (id) {
        method = "PATCH";
        url = url + "/" + id;
        data.card.id = id;
    } else {
        method = "POST";
    }

    return $.ajax({
        url: url,
        method: method,
        data: JSON.stringify(data),
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        contentType: "application/json",
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure)
        .then(__notifyCardChangesInResponse);
}

function snapshotCards(cardIds) {
    return $.ajax({
        url: "/api/cards/snapshot",
        method: "POST",
        data: { ids: __toStringArray(cardIds) },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure)
        .then((resp) => {
            if (resp.result == "success") {
                resp.cards.forEach((card) => {
                    cardChangeSource.notify(card);
                });
            }

            return resp;
        });
}

function copyCardsForCurrentUser(cardIds) {
    return $.ajax({
        url: "/api/cards/copy",
        method: "POST",
        data: { ids: __toStringArray(cardIds) },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function shareCards(cardIds, userIds, includeViewLinks, permanent = false) {
    console.log("share cards triggered: ", { cardIds, userIds, includeViewLinks, permanent });
    return $.ajax({
        url: "/api/cards/share",
        method: "POST",
        data: {
            ids: __toStringArray(cardIds),
            users: __toStringArray(userIds),
            includeViewLinks: includeViewLinks,
            permanent: permanent,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function restoreCard(cardId) {
    console.log("share cards triggered: ", { cardId });
    return $.ajax({
        url: "/api/cards/restore_card",
        method: "POST",
        data: {
            id: cardId,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function shareCardsToEveryone(cardIds, includeViewLinks) {
    return $.ajax({
        url: "/api/cards/share_to_everyone",
        method: "POST",
        data: {
            ids: __toStringArray(cardIds),
            includeViewLinks: includeViewLinks,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function exportStaticHtml(cardIds, expiration) {
    return $.ajax({
        url: "/api/export/static_html",
        method: "POST",
        data: {
            ids: __toStringArray(cardIds),
            expiration: expiration,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function publishManual(instanceId) {
    return $.ajax({
        url: "/api/export/manual",
        method: "POST",
        data: {
            instanceId: instanceId,
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function deleteCard(cardId) {
    return $.ajax({
        url: "/api/cards/" + cardId,
        method: "DELETE",
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function wipeCard(cardId) {
    return $.ajax({
        url: "/api/cards/wipe/" + cardId,
        method: "DELETE",
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure);
}

function getCard(cardId, opts = {}) {
    return loadCard(cardId, opts).then((card) => $.when(card.card));
}

function findCardsByTitle(title, callBack) {
    return $.ajax({
        url: "/api/search",
        method: "GET",
        data: {
            title: title,
            output: "json",
            glob: false, // we want an exact match
        },
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        dataType: "json",
    })
        .done(callBack)
        .fail(alerts.httpFailure);
}

function getCategories() {
    let out = [];
    for (let id in categories) {
        out.push({
            value: id,
            text: categories[id],
        });
    }
    return out;
}

function renderedCard(cardId, opts = {}) {
    return loadCard(cardId, opts);
}

function subscribe(onChange, onDelete) {
    let changeSub = cardChangeSource.subscribe(onChange);
    let deleteSub = cardDeleteSource.subscribe(onDelete);

    return changeSub.merge(deleteSub);
}

function __toStringArray(val) {
    if (Array.isArray(val)) {
        return val;
    } else {
        if (val.includes(",")) {
            return val.split(",");
        } else {
            return [val];
        }
    }
}

function publishChatMsg(card) {
    return $.ajax({
        url: "/api/cards/publish/" + card.id + "/html_chat",
        method: "PATCH",
        data: {},
        headers: {
            "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content,
        },
        contentType: "application/json",
    })
        .done(__showApiResponse)
        .fail(alerts.httpFailure)
        .then(__notifyCardChangesInResponse);
}

function checkTitle(title, cardId) {
    let url = "/api/cards/check_title?title=" + encodeURIComponent(title);
    if (cardId) {
        url += "&card_id=" + encodeURIComponent(cardId);
    }
    return $.ajax({
        url: url,
        method: "GET",
        headers: { "X-CSRF-TOKEN": document.querySelector("meta[name=csrf]").content },
    });
}

init();

module.exports = {
    listCards: listCards,
    getCard: getCard,
    saveCard: saveCard,
    publishChatMsg: publishChatMsg,
    snapshotCards: snapshotCards,
    copyCardsForCurrentUser: copyCardsForCurrentUser,
    shareCards: shareCards,
    shareCardsToEveryone: shareCardsToEveryone,
    exportStaticHtml: exportStaticHtml,
    deleteCard: deleteCard,
    wipeCard: wipeCard,
    renderedCard: renderedCard,
    subscribe: subscribe,
    listCategories: listCategories,
    isSnapshot: (card) => card.fixed,
    isCopy: (card) => card.isCopy,
    findCardsByTitle: findCardsByTitle,
    publishManual: publishManual,
    restoreCard: restoreCard,
    checkTitle: checkTitle,
};
